import { createSelector } from 'reselect'
import { getLocationQueryParamsRouterSelect } from 'modules/router/selectors'

export const getSelectedSubscriptionPlanSelect = createSelector(
  getLocationQueryParamsRouterSelect,
  queryParams => {
    return queryParams.plan
  }
)
